/** Returns whether the value is neither `null` nor `undefined`. */
export function isNotNullish<T>(value: T | null | undefined): value is T {
  return value !== null && value !== undefined;
}

/** Returns whether the value is `null` or `undefined`. */
export function isNullish(value: unknown): value is null | undefined {
  return value === null || value === undefined;
}

export type ErrOrData<T> = { err: Error; data: undefined } | { err: undefined; data: T };

/** Returns a promise that always resolves successfully, mapping errors to the content of the result value. */
export async function withError<T>(p: Promise<T>): Promise<ErrOrData<T>> {
  return new Promise<ErrOrData<T>>((resolve) => {
    p.then((data) => resolve({ data, err: undefined })).catch((err) =>
      resolve({ err, data: undefined }),
    );
  });
}
